import PageShell from "@/components/site/PageShell";
import PageHero from "@/components/site/PageHero";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { usePageContent } from "@/i18n/pageContent";

export default function Mission() {
  const c = usePageContent("mission");
  return (
    <PageShell>
      <PageHero
        eyebrow={c.eyebrow}
        title={<>{c.titleA} <span className="italic">{c.titleB}</span>.</>}
        subtitle={c.subtitle}
        image="/mission-hero.jpg"
      />
      <section className="bg-white py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <div className="space-y-7 text-[#1e293b] leading-[1.9] text-base md:text-[17px] reveal">
            <p>
              {c.p1Pre} <strong className="text-[#1a365d]">{c.p1Strong}</strong> {c.p1Post} <em>{c.p1Em}</em>{c.p1End}
            </p>
            <p>{c.p2}</p>
            <blockquote className="border-l-2 border-[#d4af37] pl-6 my-10 font-display text-2xl md:text-3xl text-[#1a365d] leading-[1.3] italic">
              &quot;{c.quote}&quot;
            </blockquote>
            <p>
              {c.p3Pre} <strong className="text-[#1a365d]">{c.p3Strong}</strong>{c.p3End}
            </p>
            <p>{c.p4}</p>
            <div className="pt-6">
              <Link to="/national-project-team" className="btn-primary">
                {c.cta}
                <ArrowRight size={14} strokeWidth={1.8} />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
